import { render, staticRenderFns } from "./transcriptForm.component.vue?vue&type=template&id=32acf701&scoped=true&"
import script from "./transcriptForm.component.vue?vue&type=script&lang=js&"
export * from "./transcriptForm.component.vue?vue&type=script&lang=js&"
import style0 from "./transcriptForm.component.vue?vue&type=style&index=0&id=32acf701&lang=scss&scoped=true&"
import style1 from "./transcriptForm.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32acf701",
  null
  
)

export default component.exports